import styled from 'styled-components';

import { Color } from '@pushwoosh/kit-constants';

export const FormStyled = styled.form`
  > * + * {
    &:not(:empty) {
      margin-top: 24px;
    }
  }
`;

export const HeaderBox = styled.div`
  > * + * {
    margin-top: 4px;
  }
`;

export const MessageBox = styled.p`
  margin-bottom: 0;
`;

export const InputFieldsBox = styled.div`
  display: flex;
  flex-direction: column;
  color: ${Color.MAIN};

  > * + * {
    margin-top: 16px;
  }
`;
